(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_d77ed93"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aoocci-split-banner-block')) {
  customElements.define('aoocci-split-banner-block', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      queueMicrotask(() => { if (this.isConnected && this.abort) this.initEntryAnimation(); });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-signup]');
        if (!button || button.closest('aoocci-split-banner-block') !== this) return;
        const status = this.querySelector('[data-signup-status]');
        if (status) status.hidden = true;
        try {
          const id = (this.dataset.formId || '').trim();
          if (!id) throw new Error('Missing form ID');
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', id]);
        } catch (error) {
          if (status) { status.textContent = 'Gamitin ang signup link sa itaas ng page para makuha ang code mo.'; status.hidden = false; }
        }
      }, { signal: this.abort.signal });
    }
    initEntryAnimation() {
      if (this.dataset.entryAnimation !== 'true' || !('IntersectionObserver' in window)) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches) return;
      const reveal = () => {
        this.entryObserver?.disconnect();
        this.classList.remove('asc-entry-ready', 'asc-entry-playing');
      };
      this.classList.add('asc-entry-ready');
      this.entryObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('asc-entry-playing');
          this.entryObserver.disconnect();
        }
      }, { threshold: 0.2 });
      this.entryObserver.observe(this.querySelector('.asc__left') || this);
      this.addEventListener('focusin', reveal, { signal: this.abort.signal });
      motion.addEventListener('change', event => { if (event.matches) reveal(); }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.entryObserver?.disconnect();
      this.classList.remove('asc-entry-ready', 'asc-entry-playing');
      this.abort?.abort(); this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
